<template>
  <li class="activity-type">
    <div class="activity-type__top">
      <div class="activity-type__category-group">
        <ActivityTypeCategory
          :category-id="parseInt(categoryId)"
          v-for="categoryId in content.categories"
          :key="categoryId"
        />
      </div>
      <div class="activity-type__titles">
        <h3 class="subtitle">{{ content.title }}</h3>
        <h4 class="small-title activity-type__small-title">{{ content.subtitle }}</h4>
      </div>
      <p>{{ content.description }}</p>
    </div>
    <NoteBlock v-if="content.details.length" :content="content.details[0]" />
  </li>
</template>

<script>
import { NoteBlock } from '@/components/blocks'
import { ActivityTypeCategory } from '@/components/small'
import { color } from '@/helpers/color.js'

export default {
  name: 'ActivityType',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: { ActivityTypeCategory, NoteBlock },
  methods: { color },
}
</script>
